import { CanDeactivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { ProductComponent } from './product.component';
import { Injectable } from '@angular/core';
import { IAppState } from '@app/store';
import { Store } from '@ngrx/store';

import { UnloadProduct } from './store/actions/product.action';

@Injectable()
export class ProductUnloadGuard implements CanDeactivate<ProductComponent> {
  constructor(private store: Store<IAppState>) {}

  canDeactivate(
    component: ProductComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): boolean {
    this.store.dispatch(new UnloadProduct(component.product));

    return true;
  }
}
